import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function StudentJobTitleValidator(): ValidatorFn {
	return (control: AbstractControl): ValidationErrors | null => {

		if (!control.value) {
			return null;
		}
		const value = control.value.trim().replace(/\s+/g, ' ');

		if (value.length < 2) {
			return { minLengthJobTitle: true };
		}

		if (value.length > 100) {
			return { maxLengthJobTitle: true };
		}

		const regex = /^[A-Za-z0-9]+(?:[A-Za-z0-9\s\-./&]*[A-Za-z0-9])?$/;

		if (!regex.test(value)) {
			return { invalidJobTitle: true };
		}

		return null;
	};
}